<template>
  <v-container v-bind="bind_container" >
    <v-layout row wrap>
      <v-flex xs12 sm12 md12>
        <v-card>
          <!-- <v-card-text  style="padding-bottom: 8px;">
            <v-layout row wrap>
              <v-flex xs10>
                <ais-search-box submit-title="search" :autofocus="true" />
              </v-flex>
              <v-flex xs2>
                <ais-clear/>
              </v-flex>
            </v-layout>
          </v-card-text> -->
          <v-expansion-panel
            :disabled="false"
            v-model="panel"
            expand>
           <v-expansion-panel-content>
              <template slot="header"><b>Filter</b></template>
              <v-card v-show="panel[0]">
                <v-card-text style="padding-top: 0px;">
                  <ais-refinement-list attribute-name="entity_types" operator="and">
                    <h3 slot="header" class="title primary--text mb-2">Type</h3>
                  </ais-refinement-list>
                  <ais-tree-menu attribute="Retailer_hierarchy" :attributes="['Retailer_hierarchy.lvl0', 'Retailer_hierarchy.lvl1', 'Retailer_hierarchy.lvl2']">
                    <h3 slot="header" class="title primary--text mb-2">Retailer</h3>
                  </ais-tree-menu>
                  <ais-tree-menu attribute="Supplier_hierarchy" :attributes="['Supplier_hierarchy.lvl0', 'Supplier_hierarchy.lvl1', 'Supplier_hierarchy.lvl2']">
                    <h3 slot="header" class="title primary--text mb-2">Supplier</h3>
                  </ais-tree-menu>
                  <!-- <ais-refinement-list attribute-name="Tags" operator="and">
                    <h3 slot="header" class="title primary--text mb-2">Tags</h3>
                  </ais-refinement-list> -->

<!-- 
                  <ais-refinement-list attribute-name="Brand" operator="and">
                    <h3 slot="header" class="title primary--text mb-2">Brand</h3>
                  </ais-refinement-list>
                  <ais-refinement-list attribute-name="Group" operator="and">
                    <h3 slot="header" class="title primary--text mb-2">Group</h3>
                  </ais-refinement-list>
                  <ais-refinement-list attribute-name="Division" operator="and">
                    <h3 slot="header" class="title primary--text mb-2">Division</h3>
                  </ais-refinement-list>
 -->
                  <!-- <ais-refinement-list attribute-name="region" operator="and" :sort-by="['name:asc']">
                    <h3 slot="header" class="title primary--text mb-2">Region</h3>
                  </ais-refinement-list>
                  <ais-refinement-list attribute-name="airport_name" operator="and" :show-search-input="true" :show-scroll-bar="true" :sort-by="['name:asc']">
                    <h3 slot="header" class="title primary--text mb-2">Airport</h3>
                  </ais-refinement-list>
                  <ais-refinement-list attribute-name="who_union" operator="and" :show-search-input="true" :show-scroll-bar="true">
                    <h3 slot="header" class="title primary--text mb-2">Who</h3>
                  </ais-refinement-list>
                  <ais-refinement-list attribute-name="how_union" operator="and" :show-search-input="true">
                    <h3 slot="header" class="title primary--text mb-2">How</h3>
                  </ais-refinement-list>
                  <ais-refinement-list attribute-name="what_union" operator="and" :show-search-input="true" :show-scroll-bar="true">
                    <h3 slot="header" class="title primary--text mb-2">What</h3>
                  </ais-refinement-list>
                  <ais-refinement-list attribute-name="product_category_union" operator="and" :show-search-input="true" :show-scroll-bar="true">
                    <h3 slot="header" class="title primary--text mb-2">Category</h3>
                  </ais-refinement-list> -->

                </v-card-text>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import AisSearchBox from '../AisComponents/AisSearchBox'
import AisClear from '../AisComponents/AisClear'
import AisRefinementList from '../AisComponents/AisRefinementList'
import AisTreeMenu from '../AisComponents/AisTreeMenu'
// import LOGGER from '@/graphql/Logger.gql'

export default {
  name: 'WikinSearchPanel',
  data () {
    return {
      panel: [(!this.$vuetify.breakpoint.mdAndDown), (!this.$vuetify.breakpoint.mdAndDown)]
    }
  },
  components: {
    AisSearchBox,
    AisClear,
    AisRefinementList,
    AisTreeMenu
  },
  computed: {
    bind_container () {
      const binding = {}
      if (this.$vuetify.breakpoint.mdAndDown) binding.style = ' padding:0px;'
      return binding
    },
    bind_advanced_search () {
      const binding = {}
      if (this.$vuetify.breakpoint.mdAndDown) binding.style = ' padding:0px;'
      return binding
    }
  },
  methods: {
  }
}
</script>
<style>
.sub_expansion_panel {
  -webkit-box-shadow: none;
  box-shadow: none;
}
</style>
